/* tslint:disable */

declare var Object: any;
export interface Sfbusinesstripdeclarationsf6Interface {
  "id"?: number;
}

export class Sfbusinesstripdeclarationsf6 implements Sfbusinesstripdeclarationsf6Interface {
  "id": number;
  constructor(data?: Sfbusinesstripdeclarationsf6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Sfbusinesstripdeclarationsf6`.
   */
  public static getModelName() {
    return "Sfbusinesstripdeclarationsf6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Sfbusinesstripdeclarationsf6 for dynamic purposes.
  **/
  public static factory(data: Sfbusinesstripdeclarationsf6Interface): Sfbusinesstripdeclarationsf6{
    return new Sfbusinesstripdeclarationsf6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Sfbusinesstripdeclarationsf6',
      plural: 'Sfbusinesstripdeclarationsf6s',
      path: 'Sfbusinesstripdeclarationsf6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Sfbusinesstripdeclarationsf6.ts